import type { Client, RequestContext } from "../client";
import type { GetProjectGroupsLookupAcrossAllSpacesBffResponse, ProjectGroupLookup, ProjectGroupResource } from "../resources";
import { BasicRepository } from "./basicRepository";
export class ProjectGroupRepository extends BasicRepository<ProjectGroupResource, ProjectGroupResource> {
    constructor(client: Client, requestContext: RequestContext) {
        super("ProjectGroups", client, requestContext);
    }
    async getProjectGroupsLookupAcrossAllSpaces(args?: {
        filterBySpace?: string;
        filterByExcludedSpace?: string;
    }): Promise<ProjectGroupLookup[]> {
        const response = await this.client.get<GetProjectGroupsLookupAcrossAllSpacesBffResponse>(this.requestContext, `~/bff/projectgroups/lookup{?filterBySpace,filterByExcludedSpace}`, args);
        return response.ProjectGroupLookup;
    }
}
